import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
import Cookies from 'js-cookie';

export const baseUrl =
  Cookies.get('Global-UserViewType') === 'demo-trading' ||
  (typeof window !== 'undefined' ? /d-[0-9a-zA-Z]+/.test(window?.location?.pathname || '') : false)
    ? publicRuntimeConfig.base.demoUrl
    : publicRuntimeConfig.base.baseUrl;
export const gatewayUrl = publicRuntimeConfig.base.gatewayUrl;
export const navUrl = publicRuntimeConfig.base.navUrl;
export const demoUrl = publicRuntimeConfig.base.demoUrl;
